import { useEffect, useState } from 'react';

interface BaseStyles {
    [key: string]: any;
}

export const getSafariCompatibleStyles = (baseStyles: BaseStyles) => {
    const [styles, setStyles] = useState(baseStyles);

    useEffect(() => {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            setStyles({
                ...baseStyles,
                height: 'calc(100vh - var(--height-header))',
                maxHeight: 'none',
            });
        }
    }, [baseStyles]);

    return styles;
};
